import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  min-height: 70vh; display: flex; align-items: center; justify-content: center;
  padding: 20px;
`;

export const Box = styled.div`
  background: #12121f; border: 2px solid rgba(255,255,255,0.1);
  border-radius: 14px; padding: 40px 32px; max-width: 400px; width: 100%;
  text-align: center;
`;

export const Icon = styled.div`font-size: 48px; margin-bottom: 16px;`;
export const Title = styled.h2`color: #fff; font-size: 20px; margin: 0 0 8px;`;
export const Sub = styled.p`color: rgba(255,255,255,0.6); font-size: 14px; margin: 0 0 20px;`;

export const Btn = styled(Link)`
  display: inline-block; background: #667eea; color: #fff;
  padding: 10px 24px; border-radius: 8px; text-decoration: none; font-weight: 600;
`;